import React,{lazy, Suspense} from "react";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

// components
// import PageLayout from "./layout/Layout";

// pages
// import Error from "../pages/error/Error";
// import Login from "../pages/login/Login";
// import Signup from "../pages/signup/Signup";
// import ResetPassword from "../pages/resetPassword/ResetPassword";
// import SetPassword from "../pages/setPassword/SetPassword";
// context
import { useUserState } from "../context/UserContext";

const PageLayout = lazy(() => import('./layout/Layout'));


const Error = lazy(() => import('../pages/error/Error'));
const Login = lazy(() => import('../pages/login/Login'));
const Signup = lazy(() => import('../pages/signup/Signup'));
const ResetPassword = lazy(() => import('../pages/resetPassword/ResetPassword'));
const SetPassword = lazy(() => import('../pages/setPassword/SetPassword'));
const RelativeConfirmation = lazy(() => import('../pages/relativeConfirmation/RelativeConfirmation'));



const antIcon = <LoadingOutlined style={{ fontSize: 50, color:"#1890ff", marginTop:"20%" }} spin />;
export default function App() {
    // global
    sessionStorage.setItem('server_api_url', process.env.REACT_APP_API_URL)
    var { isAuthenticated } = useUserState();

    return (
        <HashRouter>
            <Suspense fallback={<Spin className="loading-spin" indicator={antIcon} />}>
            <Switch>
                <Route exact path="/" render={() => <Redirect to="/app/dashboard" />} />
                <Route
                    exact
                    path="/app"
                    render={() => <Redirect to="/app/dashboard" />}
                />
                <PrivateRoute path="/app" component={PageLayout} />
                <PublicRoute path="/login" component={Login} />
                <PublicRoute path="/signup" component={Signup} />
                <PublicRoute path="/resetpassword" component={ResetPassword} />
                <PublicRoute path="/relativeConfirmation" component={RelativeConfirmation} />
                <PublicRoute path="/setpassword" component={SetPassword} />
                <Route component={Error} />
            </Switch>
            </Suspense>
        </HashRouter>
    );

    // #######################################################################

    function PrivateRoute({ component, ...rest }) {
        return (
            <Route
                {...rest}
                render={props =>
                    isAuthenticated ? (
                        React.createElement(component, props)
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/login",
                                state: {
                                    from: props.location,
                                },
                            }}
                        />
                    )
                }
            />
        );
    }

    function PublicRoute({ component, ...rest }) {
        return (
            <Route
                {...rest}
                render={props =>
                    isAuthenticated ? (
                        <Redirect
                            to={{
                                pathname: "/",
                            }}
                        />
                    ) : (
                        React.createElement(component, props)
                    )
                }
            />
        );
    }
}
